import type { InjectionKey, Ref } from 'vue'

// Per-item progress state IconList exposes to slotted icon overrides. A
// code-authored custom progress component placed in the `progressIcon` slot can
// `inject(IconListItemProgressKey)` to drive itself off the live fill value.
// The same values are also surfaced to slotted TipTaps as `comp.progress` /
// `comp.percent` / `comp.state` via IconListItemScope.
export type IconListItemState = 'pending' | 'filling' | 'done'

export interface IconListItemProgressCtx {
  // 0..100, updated each animation frame for the currently-filling item.
  progress: Ref<number>
  state: Ref<IconListItemState>
}

export const IconListItemProgressKey: InjectionKey<IconListItemProgressCtx> =
  Symbol('IconListItemProgress')
